<template>
  <section v-if="duaa && duaa.duaaId !== null">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>modifier sous duaa </v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="duaa.duaaId"
                    :return-object="false"
                    clearable
                    label="duaa"
                    item-value="id"
                    :items="duaaArray"
                    item-text="title"
                    :rules="rule"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="duaa.title"
                    label="Titre en Francais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="duaa.titleEn"
                    label="Titre en Anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Commentaire</label>
                  <VueEditor
                    v-model="duaa.comment"
                    auto-grow
                    outlined
                    label="duaaComment"
                    :rules="rule"
                    placeholder="duaa Commentaire"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Commentaire en Anglais</label>
                  <VueEditor
                    v-model="duaa.commentEn"
                    auto-grow
                    outlined
                    label="duaaComment en anglais"
                    :rules="rule"
                    placeholder="duaa Commentaire en anglais"
                  >
                  </VueEditor>
                </v-col>
              </v-row>
              <v-row
                ><v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Arabe</label>
                  <VueEditor
                    v-model="duaa.arabic_text"
                    label="Duaa en arabe"
                    outlined
                    placeholder="آيِبُونَ تَائِبُونَ عَابِدُونَ لِرَبِّنَا حَامِدُونَ"
                    persistent-placeholder
                    :rules="rule"
                    required
                  ></VueEditor>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Francais</label>
                  <VueEditor
                    v-model="duaa.french_text"
                    label="Duaa en français"
                    outlined
                    placeholder="Nous voilà de retour, repentants, dévoués et proclamant la louange de notre Seigneur."
                    persistent-placeholder
                    :rules="rule"
                    required
                  ></VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Anglais</label>
                  <VueEditor
                    v-model="duaa.english_text"
                    label="Duaa en anglais"
                    outlined
                    placeholder="Here we are back, repentant, devoted, and proclaiming the praise of our Lord."
                    persistent-placeholder
                    :rules="rule"
                    required
                  ></VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Phonetic</label>
                  <VueEditor
                    v-model="duaa.phonetic"
                    auto-grow
                    outlined
                    label="phonetic"
                    :rules="rule"
                    placeholder="Âyibûn, tâibûn, ‘âbidûn, li-Rabbinâ hâmidûn."
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <vue-upload-multiple-image
                    v-if="duaa.title"
                    v-model="images"
                    :data-images="images"
                    name="images"
                    accept="image/*	"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="duaa.numberRepetition"
                    label="Nomber de repetition"
                    type="number"
                    outlined
                    placeholder="0"
                    :min="0"
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="2">
                  <v-text-field
                    outlined
                    v-model="duaa.notificationTime"
                    label="Temp de notification"
                    model-value="12:30"
                    type="time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaa.notificationTitle"
                    label="text de notification"
                    outlined
                    placeholder="text de notification"
                    persistent-placeholder
                    v-show="
                      duaa.notificationTime !== null &&
                      duaa.notificationTime != ''
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor
                    v-model="duaa.notificationBody"
                    auto-grow
                    outlined
                    v-show="
                      duaa.notificationTime !== null &&
                      duaa.notificationTime != ''
                    "
                    label="Contenu du notification"
                    placeholder="Contenu du notification"
                  >
                  </VueEditor>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="ml-6 mt-4"
                      color="info"
                      @click="ConfirmeEditSousDuaa()"
                      :disabled="
                        duaa.arabic_text === '' ||
                        duaa.french_text === '' ||
                        duaa.english_text === '' ||
                        duaa.duaaId === null ||
                        duaa.phonetic === '' ||
                        (duaa.notificationTime !== null &&
                          duaa.notificationTime != '' &&
                          (duaa.notificationTitle === null ||
                            duaa.notificationBody === null ||
                            duaa.notificationTitle === '' ||
                            duaa.notificationBody === ''))
                      "
                      :loading="isLoading"
                    >
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditSousDuaa" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Etes vous sur de vouloir modifier le sous duaa ?
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="cancelleCallback">
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              :loading="isLoading"
              text
              @click="EditSousDuaa()"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>

<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import { getAllduaa } from "@/views/qorani/services/services";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import constants from "@/utils/constants";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import store from "../../../store/image";

export default {
  components: { VueEditor, VueCodeHighlight, VueUploadMultipleImage },
  data() {
    return {
      isLoading: false,
      duaaArray: [],
      duaa: null,
      images: [],

      phonetic: "",
      rule: [(v) => !!v || "Ce champ est requis"],
      dialogEditSousDuaa: false,
    };
  },
  methods: {
async loadImage(item) {
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          let svgContent = await response.text();
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          this.$set(item, 'svgContent', svgContent);

        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        this.$set(item, 'imgUrl', `${Constant.QORANI}fileDB/files/${item.imgDBId}`);
      }
      return item;
    },
    getImageUrl(imgDBId) {
      return `${constants.QORANI}fileDB/files/${imgDBId}`;
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.duaa.imgDBUrlId = imageId;
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.duaa.imageUrl = "";
        this.duaa.imgId = "";
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    async EditSousDuaa() {
      this.isLoading = true; // Début du chargement
      const imageId = store.state.imageId;

      if (
        this.duaa.notificationTime == "" ||
        this.duaa.notificationTime == null
      ) {
        this.duaa.notificationTitle = null;
        this.duaa.notificationBody = null;
      }
      console.log(this.duaa.notificationBody);

      try {
        const response = await fetch(
          constants.QORANI + `duaaItem/edit/${this.duaa.id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.duaa),
          }
        );

        // Check if the response status is ok
        if (response.ok) {
          this.$router.push({
            name: "SousDuaa",
          });
        } else {
          this.isLoading = false; // Fin du chargement
          this.dialogAlertError = true;
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    },
    cancelleCallback() {
      this.dialogEditSousDuaa = false;
    },
    async getSousDuaaById() {
      const duaaId = this.$route.params.id;
      try {
        const res = await fetch(`${constants.QORANI}duaaItem/get/${duaaId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const data = await res.json();
        const imagePath = data.imgDBId
          ? this.getImageUrl(data.imgDBId)
          : data.imageUrl;
        this.images.push({
          name: "",
          path: imagePath,
          highlight: 1,
          default: 1,
        });
        console.log(data);

        return data; // Return the data
      } catch (error) {
        console.error("Error fetching order list:", error);
        return null;
      }
    },
    async ConfirmeEditSousDuaa() {
      // this.dialogEditSousDuaa = true;
      this.EditSousDuaa();
    },
  },
  async created() {
    this.duaa = await this.getSousDuaaById();
    this.duaaArray = await getAllduaa();
  },
};
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>

